import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const commonObjectSlice = createSlice({
  name: "commonObjectData",
  initialState: { isModalState: false },
  reducers: {
    setModalState: (state: any, action: PayloadAction<any>) => {
      state.isModalState = action.payload;
    },
  },
});

const fileversionIdAndNodeOffsetIdMapSlice = createSlice({
  name: "fileversionIdAndNodeOffsetIdMap",
  initialState: {},
  reducers: {
    setFileversionIdAndNodeOffsetIdMap: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setModalState } = commonObjectSlice.actions;
export const { setFileversionIdAndNodeOffsetIdMap } = fileversionIdAndNodeOffsetIdMapSlice.actions;

export const commonObjectData = commonObjectSlice.reducer;
export const fileversionIdAndNodeOffsetIdMap = fileversionIdAndNodeOffsetIdMapSlice.reducer;

export default commonObjectSlice.reducer;
